<template>
  <div class="verify-pdf">
    <Row :gutter="16">
      <i-col span="20">
        <Form ref="verifyForm" :model="model" :rules="modelValidate" label-position="left" :label-width="120">
          <FormItem prop="captcha" label="验证码">
            <Input v-model="model.captcha"
              placeholder="图形验证码" style="width:140px" />
            <img :src="captchaImg" v-if="captchaImg" style="cursor:pointer;vertical-align:middle;margin-left:5px" @click="getCaptcha" />
          </FormItem>
          <FormItem prop="file" label="上传文件">
            <Upload
              :before-upload="beforeUpload"
              action="">
              <Button icon="ios-cloud-upload-outline">点击选择文件</Button>
              <span v-if="model.file">{{ model.file.name }} - {{ model.file.size }}</span>
            </Upload>
          </FormItem>
          <FormItem>
            <Button type="primary" long size="large" :disabled="!model.file" :loading="loading" @click="doUpload">验证</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
    <template v-if="verifyResult!==null&&verifyResult.title">
      <div class="padding-top-20"></div>
      <Divider>验证结果</Divider>
      <table class="brief-table" style="margin-bottom: 10px;">
        <tbody>
          <tr>
            <td colspan="2" class="title">{{ model.file.name }}</td>
          </tr>
          <tr>
            <td class="title">文件标题</td>
            <td>{{verifyResult.title}}</td>
          </tr>
          <tr>
            <td class="title">作者</td>
            <td>{{verifyResult.author}}</td>
          </tr>
          <tr>
            <td class="title">主题</td>
            <td>{{verifyResult.subject}}</td>
          </tr>
          <tr>
            <td class="title">关键字</td>
            <td>{{verifyResult.keywords}}</td>
          </tr>
          <tr>
            <td class="title">创建者</td>
            <td>{{verifyResult.creator}}</td>
          </tr>
          <tr>
            <td class="title">文件大小</td>
            <td>{{verifyResult.fileSize}}</td>
          </tr>
          <tr>
            <td class="title">哈希值</td>
            <td>{{verifyResult.hash}}</td>
          </tr>
          <tr>
            <td class="title">创建时间</td>
            <td>{{verifyResult.creationDate}}</td>
          </tr>
          <tr>
            <td class="title">修改时间</td>
            <td>{{verifyResult.modificationDate}}</td>
          </tr>
        </tbody>
      </table>
      <template v-if="verifyResult.signatures!==null&&(verifyResult.signatures instanceof Array)">
        <Divider>签名信息</Divider>
        <table class="brief-table" style="margin-bottom: 10px;" v-for="(sig,sigIdx) in verifyResult.signatures" :key="sigIdx">
          <tbody>
            <tr>
              <td colspan="2" class="title">签名{{ sigIdx+1 }}</td>
            </tr>
            <tr>
              <td class="title">签名区域</td>
              <td>{{sig.fieldName}}</td>
            </tr>
            <tr>
              <td class="title">签名时间</td>
              <td>{{$moment(sig.signDateTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
            </tr>
            <tr>
              <td class="title">签名证书</td>
              <td>{{sig.certInfo.subjectName}}</td>
            </tr>
            <tr>
              <td class="title">签名算法</td>
              <td>{{sig.certInfo.signatureAlgorithm}}</td>
            </tr>
            <tr>
              <td class="title">证书序列号</td>
              <td>{{sig.certInfo.serialNumber}}</td>
            </tr>
            <tr>
              <td class="title">证书颁发机构</td>
              <td>{{sig.certInfo.issuerName}}</td>
            </tr>
            <tr>
              <td class="title">证书有效期</td>
              <td>{{$moment(sig.certInfo.notBefore).format('YYYY-MM-DD')}} ~ {{$moment(sig.certInfo.notAfter).format('YYYY-MM-DD')}}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </template>
    <div class="padding-top-20"></div>
    <Divider/>
    <div class="font-grey small">
      <p>1. 仅支持PDF文件验证</p>
      <p>2. 支持RSA及SM2算法</p>
      <p>3. 文件大小小于10MB</p>
      <p>4. 结果仅作参考，文件有效性需自行判断</p>
    </div>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
export default {
  name: 'kvs-add',
  props: {
  },
  data () {
    return {
      loading: false,
      industries: [],
      model: {
        file: null,
        captcha: null
      },
      modelValidate: {
        captcha: [
          { required: true, message: '请填写验证码', trigger: 'blur' }
        ]
      },
      captchaImg: '',
      verifyResult: null
    }
  },
  watch: {
  },
  mounted () {
    if (!this.checkRolePermitted(['管理员'])) {
      this.$Modal.error({
        title: '错误',
        content: '无权访问该页面',
        onOk: () => {
          this.$router.back()
        }
      })
    }
    this.getCaptcha()
  },
  activated () {
  },
  deactivated () {
  },
  computed: {
  },
  methods: {
    beforeUpload (file) {
      console.log(file)
      this.model.file = file
      return false
    },
    async getCaptcha () {
      await Api.Auth(this).getCaptcha().then((img) => {
        this.captchaImg = img
      })
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    doUpload () {
      this.verifyResult = null
      this.$refs.verifyForm.validate((valid) => {
        console.log(this.model)
        if (valid) {
          this.loading = true
          this.$Spin.show()
          let model = Object.assign({}, this.model)
          Api.Guarantee.verifyPdfFile(model.file, model.captcha)
            .then((payload) => {
              console.log('suc', payload)
              this.verifyResult = payload
              this.$Message.success('验证完成')
              this.model.captcha = null
              this.loading = false
              this.$Spin.hide()
              this.getCaptcha()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('验证失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
              this.getCaptcha()
            })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
